<template>
    <div class="sidebar">
        <div class="tabs">
            <div v-if="menus.length > 1">
                <swiper ref="sidebarMenus" :options="swiperOptions">
                    <swiper-slide v-for="(item, index) in menus" :key="index" >
                        <div
                            :class="[
                                'swiper__inner',
                                { 'active-tab' : index === activeIndex }
                            ]"
                            :style="{'--color': index === activeIndex && $store.state.lingkeColor}"
                            @click="clickTab(index)">
                            {{item.name}}
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <!-- <div v-else class="single-tab" :style="{'--color': $store.state.lingkeColor}">
                <span>{{menus[activeIndex].name}}</span>
            </div> -->
        </div>
        <div class="imgs">
            <swiper ref="imgSwiper" :options="imgOption" v-if="renderSwiper">
                <swiper-slide v-for="(item, index) in currentMenu.image_urls" :key="index">
                    <div class="el-image"><img :src="item"></div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="hot-questions" v-if="currentMenu.hot_questions.length">
            <div class="title" :style="{'--color': $store.state.lingkeColor}">热门问题</div>
            <div class="hot-questions-content">
                <div class="hot-questions-item" v-for="(item, index) in currentMenu.hot_questions" :key="index">
                    <el-tooltip placement="top-start" :content="item.question" :open-delay="500">
                        <span @click="clickItem(item.question)">{{item.question}}</span>
                    </el-tooltip>
                    <i class="el-icon-arrow-right" @click="clickItem(item.question)"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'
    export default {
        name:'sidebar',
        props: {
            options: {
                type: Object
            }
        },
        computed:{
            menus () {
                return this.options.content
            },
            currentMenu () {
                return this.options.content[this.activeIndex]
            },
            imgOption () {
                let option = {
                    observer: true,
                    observeParents: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    loop: true,
                    loopAdditionalSlides: 100,
                }
                if (this.options.content[this.activeIndex].image_urls.length === 1) {
                    option.loop = false
                }
                return option
            }
        },
        data () {
            return {
                swiperOptions: {
                    observer: true,
                    observeParents: true,
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled'
                    },
                    // slideToClickedSlide: true,
                    on: {
                        click: function () {
                            this.slideTo(this.clickedIndex - 1, 100, false)
                        }
                    }
                },
                activeIndex: 0, // 当前项索引
                renderSwiper: true
            }
        },
        methods: {
            clickTab (index) {
                this.activeIndex = index
                this.renderSwiper = false
                this.$nextTick(()=>{
                    this.renderSwiper = true
                })
            },
            clickItem (text) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            },
        }
    }
</script>
<style lang="scss" scoped>
.sidebar {
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    background: #000;
    .swiper {
        &-slide {
            width: fit-content;
            text-align: center;
        }
        &__inner {
            color: #fff;
            line-height: 39px;
            cursor: pointer;
            position: relative;

            &.active-tab {
                color: var(--color);
                font-weight: 600;
                &::after {
                    content: '';
                    height: 1px;
                    width: 100%;
                    background: var(--color);
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
            }
        }
    }
    .single-tab {
        color: var(--color);
        font-weight: 600;
        line-height: 39px;
        text-align: center;
        cursor: pointer;
    }
    .imgs {
        margin-top: 10px;
        .swiper-slide {
            width: 100%;
            text-align: center;
        }
        .el-image {
            width: 100%;
            height: 140px;
            img{
                max-width: 100%;
            }
        }
    }
    .hot-questions {
        margin-top: 10px;
        height: 100%;
        overflow-y: scroll;
        .title {
            color: var(--color);
            font-weight: 600;
            line-height: 39px;
            font-size: 16px;
        }
        &-content {
            padding: 0 10px;
            max-height: 350px;
            // overflow: scroll;
        }
        &-item {
            color: #fff;
            line-height: 40px;
            width: 100%;
            border-bottom: 1px dashed #80807F;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .el-tooltip {
                width: 85%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            span,i {
                cursor: pointer;
            }
        }
    }
}
</style>
